import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Initial state
const initialState = {
  groupSidebarOpen: false,
  groupDashboardHeader: "",
  encryptedHotelId: null,
  openFlexiAi: false,
};

// Create the slice
const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setGroupSidebarOpen(state, action) {
      state.groupSidebarOpen = action.payload;
    },
    setGroupDashboardHeader(state, action) {
      state.groupDashboardHeader = action.payload;
    },
    setEncryptedHotelId(state, action) {
      state.encryptedHotelId = action.payload;
    },
    setOpenFlexiAi(state, action) {
      state.openFlexiAi = action.payload;
    },
  },
});

// Export actions
export const {
  setGroupSidebarOpen,
  setGroupDashboardHeader,
  setEncryptedHotelId,
  setOpenFlexiAi,
} = uiSlice.actions;

// Persist configuration
const persistConfig = {
  key: "ui",
  storage,
};

// Export persisted reducer
const persistedReducer = persistReducer(persistConfig, uiSlice.reducer);
export default persistedReducer;
